module.exports = __webpack_public_path__ + "static/media/044-farmer.f04a69c9.svg";